import { Injectable } from '@angular/core';
import {Observable} from "rxjs/Observable";
export interface OnWBStateLimit{
    wbStateLimitReached();
}
export interface OnNoMoreStreams{
    onNoMoreStreams();
}
@Injectable()
export class WbService {
    constructor(){
        console.log("Creating wb service")
    }
    demo = false;
    setDemo(to){
        this.demo = to;
    }
    isDemo(){
        return this.demo;
    }
    showChat(){
        return this._showChat;
    }
    _showChat=true;
    setShowChat(to){
        this._showChat = to;
    }
    onStateCallbacks=[];
    onSessionsCallbacks=[];
    onMathCallbacks=[];
    onResizeCallbacks=[];
    onFileCallbacks=[];
    onWBStateLimitCallbacks=[];
    setTeacherWbHash(hash){
        this.teacherWbHash = hash;
    }
    teacherWbHash;
    getTeacherWbHash(){
        return this.teacherWbHash;
    }
    onState(type, cb){
        if (!this.onStateCallbacks[type])this.onStateCallbacks[type]=[];
        console.log("ADding state "+type+" handler")
        this.onStateCallbacks[type].push(cb);
    }
    wbStateLimitReached(){
        for (let c of this.onWBStateLimitCallbacks){
            c.wbStateLimitReached();
        }
    }
    unergisterFromWbStateLimitReached(cb){
        for (let k in this.onWBStateLimitCallbacks){
            if (this.onWBStateLimitCallbacks[k]==cb){
                delete this.onWBStateLimitCallbacks
            }
        }
    }
    
    noMoreStreams(){
        console.log("Will call the callbacks");
        for (let c of this.onNoMoreStreams){
            c.onNoMoreStreams();
        }
    }
    onNoMoreStreams;
    registerForOnNoMoreStreams(c: OnNoMoreStreams){
        if (!this.onNoMoreStreams)
            this.onNoMoreStreams=[];
        this.onNoMoreStreams.push(c);
    }
    registerForWbStateLimitReached(c: OnWBStateLimit){
    
        if (!this.onWBStateLimitCallbacks)
            this.onWBStateLimitCallbacks=[];
        this.onWBStateLimitCallbacks.push(c);
    }
   gotState(type, state){
       console.log("Will check on state callbackes ", this.onStateCallbacks);
      // if (this.onStateCallbacks[type])
       for (var i =0;i<this.onStateCallbacks[type].length;i++){
           this.onStateCallbacks[type][i].call(this, state);
       }
   }
   leftPeers = false;
   
 
   onMathRow(w, r){
       for (var cb of this.onMathCallbacks){
        try{
            cb.onMathRow(w, r);
       }catch(error ){}
       }
   }
   registerForMathRow(cb){
       this.onMathCallbacks.push(cb);
   }
   unregisterOnFileCallback(cb){
        for (var i =0;i<this.onFileCallbacks.length;i++){
        if (cb == this.onFileCallbacks[i]){
            delete this.onFileCallbacks[i];
        }
        }
   }
   unregisterOnresizeCallback(cb){
       for (var i =0;i<this.onResizeCallbacks.length;i++){
        if (cb == this.onResizeCallbacks[i]){
            console.log("Will clean resize callback", this.onResizeCallbacks[i])
                delete this.onResizeCallbacks[i];
                console.log("Resize callback deleted", this.onResizeCallbacks[i])
        }
       }
   }
   onResize(){
       for (var c in this.onResizeCallbacks){
           this.onResizeCallbacks[c].onResize();
       }
   }
   registerOnResize(cb){
        this.onResizeCallbacks.push(cb);
   }
   registerOnFileCallback(cb){
       this.onFileCallbacks.push(cb);
   }
   
   showFile(file){
       for (var c in this.onFileCallbacks) {
           this.onFileCallbacks[c].showFile(file);
       }
   }
   registerForSessionsCallback(cb){
       this.onSessionsCallbacks.push(cb);
   }
   onSessions(sessions){
       for (var cb of this.onSessionsCallbacks){
           cb.onSessions(sessions);
       }
   }
   updateLayout(media){
    switch (media){
      case "me-audio": 
      case "me-both":
      case "audio": this.setLayout(true);break;
      case "both": this.setLayout(false);break;
    }
  }
  private setLayout(leftPeers){
    this.leftPeers = leftPeers;
    var self = this;
    setTimeout(function(){
    self.onResize();
    }, 100);
  }
}



// WEBPACK FOOTER //
// /app/src/app/wb/wb.service.ts